export const fields = [

]
export const payment_order_ex = [{
    name: '离职补偿',
    code: 'Q',
  },
  {
    name: '离职补偿个税',
    code: 'QT',
  }
]
export const ALL = 'ALL'
// 付款申请 正式员工工资相关
export const provision_common_fields = [
  {
      name: '全选',
      code: ALL,
  },
  {
    name: '固薪',
    code: 'W',
  },
  {
    name: '提成',
    code: 'C',
  },
  {
    name: '工资个税',
    code: 'WT',
  },
  {
    name: '餐补',
    code: 'SD',
  },
  {
    name: '推荐奖',
    code: 'R',
  },
  {
    name: '社保',
    code: 'S',
  },
  {
    name: '社保(个人)',
    code: 'SP',
  },
  {
    name: '公积金',
    code: 'H',
  },
  {
    name: '公积金(个人)',
    code: 'HP',
  
  },
  {
    name: '绩效奖金',
    code: 'P',
  },
  {
    name: '绩效奖金个税',
    code: 'PT',
  },
  {
    name: '分红奖金',
    code: 'D',
  },
  {
    name: '分红奖金个税',
    code: 'DT',
    
  },
  {
    name: '其他奖金',
    code: 'O',
  },
  {
    name: '离职补偿',
    code: 'Q',
  },
  {
    name: '离职补偿个税',
    code: 'QT',
  },
  {
    name: '其他奖金个税',
    code: 'OT',
  }
]
export const provision_1_fields = provision_common_fields
// 发票提交（应付单）正式员工工资相关
export const provision_8_fields = provision_common_fields
// 账单提交单
export const provision_9_fields = [
    {
        name: '全选',
        code: ALL,
    },
    {
      name: '固薪',
      code: 'W',
    },
    {
      name: '提成',
      code: 'C',
    },
    {
      name: '推荐奖',
      code: 'R',
    },
    {
      name: '餐补',
      code: 'SD',
    },
    {
      name: '社保',
      code: 'S',
    },
    {
      name: '公积金',
      code: 'H',
    },
    {
      name: '离职补偿',
      code: 'Q',
    },
    {
      name: '预估绩效奖金',
      code: 'P',
    },
    // {
    //   name: '实际十五薪',
    //   code: 'YA',
    // },
    {
      name: '实际绩效奖金',
      code: 'PA',
    },
    {
      name: '分红奖金',
      code: 'D',
    },
    {
      name: '其他奖金',
      code: 'O',
    }
  ]

export const staff_types = [
    {
        label: '正式员工',
        value: 1
    },
    {
        label: '非正式员工',
        value: 2
    }
]

export const informal_staff_type_1 = [
    {
        label: '实习生津贴',
        value: 'informal_wage'
    },
    {
      label: '实习生个税',
      value: 'informal_tax'
  },
    {
        label: '实习生餐补',
        value: 'informal_subsidy'
    }
]

export const informal_staff_type_9 = [
    informal_staff_type_1[0],
    informal_staff_type_1[2],
    {
        label: '兼职外包工资计提',
        value: 'outsource_wage'
    },
    {
        label: '实习生推荐奖计提',
        value: 'rec_award'
    },
]

export const list_types_hash = {
    1: informal_staff_type_1,
    9: informal_staff_type_9
}
// 不同类型的单子所对应的项目
export const regular_employee_hash = {
    1: provision_1_fields,
    8: provision_8_fields,
    9: provision_9_fields
}

export const button_title_hash = {
    1: '生成工资付款单',
    8: '生成工资应付单',
    9: '生成工资计提单'
}

export const title_hash = {
    1: '工资付款单',
    8: '工资应付单',
    9: '工资计提单'
}


export const payment_batch = [
  {
    label: '正常发放',
    value: 'normal'
  },
  {
    label: '补发',
    value: 'reissue'
  }
]